export function getAdminPanelRequestHeaders(
  firebaseIdToken: string | null | undefined,
): Record<string, string | null> {
  return {
    'X-Client-Type': 'admin-panel',
    authorization: firebaseIdToken ?? null,
  };
}

export function getAdminPanelFetchHeaders(
  firebaseIdToken: string | null | undefined,
): Record<string, string> {
  const headers: Record<string, string> = {
    'X-Client-Type': 'admin-panel',
  };
  if (firebaseIdToken) {
    headers.authorization = firebaseIdToken;
  }
  return headers;
}
